import { Injectable } from '@angular/core';
import { Repository } from '../services/Repository';
import { BehaviorSubject } from 'rxjs';
@Injectable({
    providedIn: 'root'
})
export class TrackingService {

    constructor(private _repo: Repository) {
    }

    trackEvent(pageViewName: string, eventName: string, mobileNo: string, otherInformation: string) {
        const event = {
            PageViewName: pageViewName,
            EventName: eventName,
            MobileNo: mobileNo,
            OtherInformation: otherInformation
        };

        this._repo.postMethodWithHeaderParamWC_WithoutTokenTracking("Kyc/TrackEventDetailsAsync", event).subscribe((result: any) => {
        });
    }

    
    private usernameSource = new BehaviorSubject<string>(''); // Initial value can be set as needed
    username$ = this.usernameSource.asObservable();

    setUsername(username: string) {
        this.usernameSource.next(username);
    }
}